import { OpenFeature, useBooleanFlagValue } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from './constants';

/**
 * English-market gate from the browser UI language — works pre- and post-auth
 * (Flagsmith trait targeting can't, since context sync no-ops until identified).
 * Primary subtag `en` covers every variant (en-US/GB/AU/NZ/IN). Proxy for
 * market, not the user's saved region.
 */
export const isEnglishMarket = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const [primarySubtag = ''] = navigator.language.toLowerCase().split('-');
  return primarySubtag === 'en';
};

/**
 * Exclude this user from an English-only experiment? Pass the experiment's own
 * `op-…-english-only` flag (default ON = restrict to English; flip OFF to expand
 * that one experiment to all regions without a deploy). Compose into the
 * experiment's gate; the excluded branch picks its own fallback.
 */
export const isExcludedByEnglishOnly = (englishOnlyFlagKey: string): boolean =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(englishOnlyFlagKey, true) &&
  !isEnglishMarket();

/** Hook form of {@link isExcludedByEnglishOnly}. */
export const useIsExcludedByEnglishOnly = (englishOnlyFlagKey: string): boolean => {
  const enforced = useBooleanFlagValue(englishOnlyFlagKey, true);
  return enforced && !isEnglishMarket();
};
